import { render, staticRenderFns } from "./factoryLogin.vue?vue&type=template&id=83964d5c&scoped=true&"
import script from "./factoryLogin.vue?vue&type=script&lang=js&"
export * from "./factoryLogin.vue?vue&type=script&lang=js&"
import style0 from "./factoryLogin.vue?vue&type=style&index=0&id=83964d5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83964d5c",
  null
  
)

export default component.exports